import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Grid, Row, Col, Image, Panel, Button } from 'react-bootstrap'

export const View = ({ isLogged }) => {
	return <Grid fluid>
		<Row className="show-grid">
			<Col lg={2} md={4} sm={6} xs={8} lgOffset={5} mdOffset={4} smOffset={3} xsOffset={2}>
				<Image src="/img/logo.svg" responsive className="center-block mt"  />
				<Panel>
					<Panel.Body>
						<h2 className="text-center mt-0">404</h2>
						<p className="text-center">... Ups this page was not found!</p>
						<Link to={isLogged ? '/home' : '/'}>
							<Button type="submit" bsStyle="primary" className="center-block">Go home!</Button>
						</Link>
					</Panel.Body>
				</Panel>
			</Col>
		</Row>
	</Grid>
}

View.propTypes = {
	isLogged: PropTypes.bool
}

export default View



// WEBPACK FOOTER //
// ./src/routes/Error/components/View.js